import type { SectionTileCategoryRight1Big } from '#domains/resolver/board-section-data';
import { Tracktor } from 'react-tracktor';

import { IMAGE_SIZE_TWO_THIRD } from '../../BoardImageSizes';
import { BoardSectionItem } from '../BoardSectionItem';
import { BoardSectionItemFeed } from '../Items/BoardSectionItemFeed';
import { BoardSectionTileRow } from '../Tile/TileRow';
import { BoardSectionTileSection } from '../Tile/TileSection';

type Props = {
	boardSectionItems: SectionTileCategoryRight1Big['items'];
	isHighlightSection?: boolean;
};

export function BoardSectionTileCategoryRight1({ boardSectionItems }: Props) {
	if (boardSectionItems.left.type === 'empty') {
		return null;
	}

	return (
		<BoardSectionTileSection>
			<BoardSectionTileRow>
				<Tracktor trackingData={{ data: { inSectionPlacement: 0 } }}>
					<BoardSectionItem teaser={boardSectionItems.left} isLarge={true} sizes={IMAGE_SIZE_TWO_THIRD} />
				</Tracktor>

				<Tracktor trackingData={{ data: { inSectionPlacement: 1 } }}>
					<BoardSectionItemFeed teasers={boardSectionItems.feedItems} />
				</Tracktor>
			</BoardSectionTileRow>
		</BoardSectionTileSection>
	);
}
